class ProductTimeline extends HTMLElement {
  constructor() {
    super();
    this.section = null;
    this.stages = null;
    this.timeframes = null;
    this.observer = null;
  }

  connectedCallback() {
    this.section = this.querySelector('#productTimeline') || this.querySelector('.product-timeline');
    this.init();
  }

  init() {
    if (!this.section) {
      console.warn('Product Timeline: Section not found');
      return;
    }

    this.stages = this.section.querySelectorAll('.product-timeline__stage');
    this.timeframes = this.section.querySelectorAll('.product-timeline__timeframe');

    if (this.stages.length === 0) {
      console.warn('Product Timeline: No stages found');
      return;
    }

    // Set first stage as active by default
    this.stages[0].classList.add('active');

    // Debug markers
    // this.addDebugMarkers();

    // Observe the timeframe headings instead of full blocks
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Array.from(this.timeframes).indexOf(entry.target);
            console.log('Timeline: Timeframe', index, 'entered viewport');
            this.setActiveStage(index);
          }
        });
      },
      {
        root: null,
        rootMargin: '-30% 0px -60% 0px', // Trigger when heading is in top 30-40% of viewport
        threshold: 0
      }
    );

    this.timeframes.forEach((timeframe) => {
      this.observer.observe(timeframe);
    });
  }

  setActiveStage(index) {
    this.stages.forEach((stage, i) => {
      if (i === index) {
        stage.classList.add('active');
      } else {
        stage.classList.remove('active');
      }
    });
  }

  addDebugMarkers() {
    const topMarker = document.createElement('div');
    topMarker.style.cssText = 'position: fixed; top: 30%; left: 0; right: 0; height: 2px; background: green; z-index: 9999; pointer-events: none;';
    topMarker.innerHTML = '<span style="position: absolute; left: 10px; top: -20px; background: green; color: white; padding: 2px 6px; font-size: 12px;">trigger start (30%)</span>';
    document.body.appendChild(topMarker);

    const bottomMarker = document.createElement('div');
    bottomMarker.style.cssText = 'position: fixed; top: 40%; left: 0; right: 0; height: 2px; background: red; z-index: 9999; pointer-events: none;';
    bottomMarker.innerHTML = '<span style="position: absolute; left: 10px; top: 4px; background: red; color: white; padding: 2px 6px; font-size: 12px;">trigger end (40%)</span>';
    document.body.appendChild(bottomMarker);

    this.debugMarkers = [topMarker, bottomMarker];
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.debugMarkers) {
      this.debugMarkers.forEach(m => m.remove());
    }
  }
}

if (!customElements.get('product-timeline')) {
  customElements.define('product-timeline', ProductTimeline);
}
